import Vue from 'vue';

const ProductSearchModule = {
    namespaced: true,
    state: () => ({
        selectedProducts: {
            isOpened: false,
            skus: {},
            products: {},
            list: []
        }
    }),
    getters: {
        isset: state => ({ product, type }) => {
            return typeof state.selectedProducts[type][product['id']] !== "undefined";
        },
        isProductInSkus: state => productId => {
            for (let i in state.selectedProducts.skus) {
                if (state.selectedProducts.skus[i] === productId) {
                    return true;
                }
            }
        }
    },
    mutations: {
        add(state, { product, type }) {
            const productId = type === 'skus' ? product.product_id : product.id;
            if (type === 'skus' && typeof state.selectedProducts['products'][productId] !== "undefined") {
                Vue.delete(state.selectedProducts['products'], productId);
                const index = state.selectedProducts.list.findIndex(filterProduct => (filterProduct.type === 'products' && filterProduct.id === productId));
                if (index !== -1) {
                    state.selectedProducts.list.splice(index, 1);
                }
            } else if (type === 'products') {
                state.selectedProducts.list = state.selectedProducts.list.filter((selectedProduct) => {
                    if (selectedProduct.type === 'skus' && selectedProduct.product_id === productId) {
                        Vue.delete(state.selectedProducts['skus'], selectedProduct.id);
                    } else {
                        return true;
                    }
                });
            }

            Vue.set(state.selectedProducts[type], product.id, productId);
            product['type'] = type;
            state.selectedProducts.list.push(product);
        },
        remove(state, { product, type }) {
            const id = Number.isInteger(product) ? product : product['id'];
            Vue.delete(state.selectedProducts[type], id);
            const index = state.selectedProducts.list.findIndex(filterProduct => (filterProduct.type === type && filterProduct.id === id));
            state.selectedProducts.list.splice(index, 1);
        },
        update(state, value) {
            state.selectedProducts.list = value;
            Vue.set(state.selectedProducts, 'skus', {});
            Vue.set(state.selectedProducts, 'products', {});
            state.selectedProducts.list.forEach((product) => {
                Vue.set(state.selectedProducts[product.type], product.id, product.product_id);
            });
        },
        updateOpenedStatus(state, value) {
            state.selectedProducts.isOpened = value;
        }
    }
};

export default ProductSearchModule;